export default __webpack_public_path__ + "static/media/9S.46bbe483.png";